<div *ngFor="let menuItem of menuItems" class="menu-item">
  <a *ngIf="menuItem.routerLink && !menuItem.hasSubMenu" mat-button fxLayout="row" fxLayoutAlign="start center"
      [routerLink]="[menuItem.routerLink]" (click)="onClick(menuItem.id)" [id]="'menu-item-'+menuItem.id">
      <span class="menu-title" style="font-size: 18px;">{{ menuItem.title | translate }}</span>
  </a>
</div>